import React, { useState } from 'react';
import { Grid, Typography, IconButton, Divider } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationModal from '../modals/ConfirmationModal/ConfirmationModal';
import { TaskWorksheet } from '../../types/interfaces';

interface TaskWorksheetsComponentProps {
  selectedFile: any[];
  onDelete: (worksheetId: number) => void;
  index: any;
}

const TaskWorksheetsUpload: React.FC<TaskWorksheetsComponentProps> = ({
  selectedFile,  
  onDelete,
  index,
}) => {

  return (
    selectedFile?.filter(x => x.index === index).length > 0 ?
    <>
      <Typography variant="subtitle2" color={'secondary'}>
        Templates por guardar
      </Typography>
      <Divider />

      {selectedFile?.filter(x => x.index === index).map((obj, i) => (
        <Grid container spacing={2} key={i}>
          <Grid item xs={4} mt={0}>
            <Typography fontSize={'14px'}>{obj?.file?.name}</Typography>
          </Grid>
          <IconButton onClick={() => onDelete(obj)}>
                <DeleteIcon color="error" />
              </IconButton>
        </Grid>
      ))}

    </>
    :
    <></>
  );
};

export default TaskWorksheetsUpload;
